import { RegisterForm } from "@/features/user/forms/register-form";
import { appTitleHead } from "@/lib/app-document-title";
import { useTranslation } from "@/lib/i18n/client";
import { createFileRoute } from "@tanstack/react-router";
import { useLng } from "@/hooks/use-lng";

export const Route = createFileRoute("/_app/account/register")({
  head: () => appTitleHead("create-account"),
  component: RegisterPage
});

function RegisterPage() {
  const lng = useLng();
  const { t } = useTranslation(lng, "translation");

  return (
    <div>
      <h1 className="hidden text-left md:block">{t("create-account")}</h1>
      <p className="mb-5">{t("create-account-first-description")}</p>
      <h2 className="pb-0 text-base font-bold">{t("create-account-second-title")}</h2>
      <p>{t("create-account-second-description")}</p>
      <RegisterForm />
    </div>
  );
}
